import type { DateFormat } from '../../types';

export function formatDate(inputDate: string, dateFormat: DateFormat): string {
  const date = new Date(inputDate);

  if (isNaN(date.getTime())) return '';

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  return (
    {
      'MM/DD/YYYY': `${month}/${day}/${year}`,
      'DD/MM/YYYY': `${day}/${month}/${year}`,
      'YYYY/MM/DD': `${year}/${month}/${day}`
    }[dateFormat] || ''
  );
}

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
